import { useNavigate } from 'react-router-dom'

import { Button, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'
import DeleteModal from 'modules/space_control/components/BookingsDatatable/Modals/DeleteModal'
import { BookingNode } from 'modules/space_control/hooks/bookings/useBooking'

interface Props {
  booking: BookingNode
}

const BookingsPopoverMenu = ({ booking }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const updateVerb = 'spacecontrol.booking.upsert'
  const cancelVerb = 'spacecontrol.booking.bulk_cancel'
  const [deleteModalOpen, toggleDeleteModal] = useToggle(false)
  const {
    access: { id: accessId },
  } = useCurrentSession()
  const employeeId = booking?.access?.employee?.id
  const isOwner = booking?.access?.id === accessId
  const canUpdate =
    users.current.policy.can('spaceControl.bookingEditEverybody') ||
    (users.current.policy.can('spaceControl.bookingEditSelf') && isOwner) ||
    (employeeId &&
      policyAuthorizations.for(updateVerb, {
        id: employeeId,
        policyTargetClass: '::Employee',
      }))
  const canCancel =
    users.current.policy.can('spaceControl.bookingCancelEverybody') ||
    (users.current.policy.can('spaceControl.bookingCancelSelf') && isOwner) ||
    (employeeId &&
      policyAuthorizations.for(cancelVerb, {
        id: employeeId,
        policyTargetClass: '::Employee',
      }))

  if (!canUpdate && !canCancel) {
    return <></>
  }

  return (
    <>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative
            type="secondary"
            aria-label="Project popover menu button"
            iconName="ellipsis"
          />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end">
          {canUpdate && (
            <PopoverMenu.TouchableOption
              title={i18n.t('space_control.my-bookings.datatable.menu_options.edit')}
              onClick={() => {
                navigate(
                  navigation.spaceControl.bookings.edit.fullPath({ bookingId: booking.id ?? '' })
                )
              }}
            />
          )}
          {canCancel && (
            <PopoverMenu.TouchableOption
              danger
              title={i18n.t('space_control.my-bookings.datatable.menu_options.delete')}
              onClick={toggleDeleteModal(true)}
            />
          )}
        </PopoverMenu.Content>
      </PopoverMenu>
      {deleteModalOpen && <DeleteModal booking={booking} toggleModal={toggleDeleteModal(false)} />}
    </>
  )
}
export default observer(BookingsPopoverMenu)
